export default __webpack_public_path__ + "media/chat-dsc-2.ddb65e3e.svg";